/**
 * Rounded Button
 *
 * @format
 */

import { IconNode, ButtonProps as RNButtonProps } from '@rneui/base'
import { Button, makeStyles } from '@rneui/themed'
import { font } from 'app/theme'
import React from 'react'
import { GestureResponderEvent, StyleProp, ViewStyle } from 'react-native'

interface ButtonProps {
  title: string
  onPress: (event: GestureResponderEvent) => void
  emphasized?: boolean
  danger?: boolean
  loading?: boolean
  containerStyle?: StyleProp<ViewStyle>
  buttonStyle?: any
  titleStyle?: any
  disabled?: boolean
  icon?: IconNode
  iconPosition?: RNButtonProps['iconPosition']
}

export function RoundedButton(props: ButtonProps) {
  const styles = useStyles(props)

  return (
    <Button
      onPress={props.onPress as any}
      title={props.title}
      containerStyle={props.containerStyle}
      titleStyle={[styles.title, props.titleStyle]}
      titleProps={{ allowFontScaling: false }}
      loading={props.loading}
      loadingProps={styles.loading}
      buttonStyle={[styles.button, props.buttonStyle]}
      disabled={props.disabled}
      icon={props.icon}
      iconPosition={props.iconPosition}
    />
  )
}

export const BUTTON_HEIGHT = 40

const useStyles = makeStyles((theme, props: ButtonProps) => ({
  button: {
    height: BUTTON_HEIGHT,
    borderRadius: 15,
    borderWidth: theme.mode === 'light' && !props.danger ? 0.5 : 0,
    borderColor: theme.colors.black,
    backgroundColor: props.danger
      ? theme.colors?.primary
      : theme.mode === 'light'
      ? 'white'
      : theme.colors?.grey9,
  },
  title: {
    textAlign: 'center',
    fontSize: 17,
    fontFamily: font.bold,
    color: props.danger
      ? 'white'
      : props.emphasized
      ? theme.mode === 'light'
        ? theme.colors.red
        : theme.colors.peach
      : theme.mode === 'light'
      ? theme.colors.grey9
      : 'white',
  },
  loading: {
    color: theme.colors?.black,
  },
}))
